export const CRUK_MESSAGE_BACKGROUND_COLOR = '#F1F1F1'
export const CRUK_ACCENT_COLOR = '#E60079'
